module.exports = __webpack_public_path__ + "img/prof6.3bb75b18.jpg";